import * as React from 'react';
// @ts-ignore
import { Secondary } from '@churchofjesuschrist/eden-buttons';
// @ts-ignore
import { Error } from '@churchofjesuschrist/eden-alert';
import { Address } from '@msdyn365-commerce/retail-proxy';

export const UruguayCheckout: React.FC<any> = ({
    resources,
    customSetAddress,
    setIsDisabled,
    filteredItems,
    defaultCountryRegionId,
    currentAddress,
    addressItems
}) => {
    const [name, setName] = React.useState<string>('');
    const [betweenStreet, setBetweenStreet] = React.useState<string>('');
    const [street, setStreet] = React.useState<string>('');
    const [postalCode, setPostalCode] = React.useState('');
    const [stateId, setStateId] = React.useState<any>('');
    const [address, setAddress] = React.useState<any>([]);
    const [zipcode, setZipcode] = React.useState<any>('');
    const [city, setCity] = React.useState<any>('');
    const [countryRegionName, SetCountryRegionName] = React.useState<any>('');

    React.useEffect(() => {
        if (name !== '' && street !== '' && stateId !== '' && city !== '') {
            setIsDisabled(false);
        } else {
            setIsDisabled(true);
        }
    }, [address]);

    React.useEffect(() => {
        let countryList;
        let countryValue;
        if (addressItems) {
            countryList = addressItems.filter((item: any) => {
                return item.key === 'ThreeLetterISORegionName';
            });
        }

        if (
            countryList &&
            countryList[0] &&
            countryList[0].input &&
            countryList[0].input.props &&
            countryList[0].input.props.displayData &&
            defaultCountryRegionId
        ) {
            countryValue = countryList[0].input.props.displayData.filter((country: any) => {
                return country.key === defaultCountryRegionId;
            });
        }

        if (countryValue && countryValue[0]) {
            SetCountryRegionName(countryValue[0].value);
        }
    }, []);

    React.useEffect(() => {
        if (currentAddress && currentAddress.Name && currentAddress.Name !== '') {
            setName(currentAddress.Name);
        }
        if (currentAddress && currentAddress.State && currentAddress.State !== '') {
            setStateId(currentAddress.State);
        }
        if (currentAddress && currentAddress.ZipCode && currentAddress.ZipCode !== '') {
            setZipcode(currentAddress.ZipCode);
            setPostalCode(currentAddress.ZipCode);
        }
        if (currentAddress && currentAddress.City && currentAddress.City !== '') {
            setCity(currentAddress.City);
        }
        if (currentAddress && currentAddress.Street && currentAddress.Street !== '') {
            const streetSplit = currentAddress.Street.split('\n');
            if (streetSplit && streetSplit[0]) {
                setStreet(streetSplit[0]);
            }
            if (streetSplit && streetSplit[1]) {
                setBetweenStreet(streetSplit[1]);
            } else if (currentAddress.Street_2 && currentAddress.Street_2 !== '') {
                setBetweenStreet(currentAddress.Street_2);
            }
        }
        if (currentAddress) {
            setAddress(currentAddress);
        }
    }, []);

    const selectState = async (state: any) => {
        const selectedState = filteredItems.filter((county: any) => {
            return county.key === state;
        });

        const customAddress: Address = {
            Name: name,
            Street: betweenStreet && betweenStreet !== '' ? `${street}\n${betweenStreet}` : `${street}`,
            State: selectedState[0].key,
            City: city,
            ZipCode: zipcode
        };
        customSetAddress(customAddress);
        setStateId(state);
        setAddress(customAddress);
    };

    const customSetName = (name: any) => {
        const customAddress: Address = {
            Name: name,
            City: city,
            Street: betweenStreet && betweenStreet !== '' ? `${street}\n${betweenStreet}` : `${street}`,
            State: stateId,
            ZipCode: postalCode
        };

        customSetAddress(customAddress);
        setAddress(customAddress);
        setName(name);
    };

    const customSetCity = (city: any) => {
        const customAddress: Address = {
            Name: name,
            City: city,
            Street: betweenStreet && betweenStreet !== '' ? `${street}\n${betweenStreet}` : `${street}`,
            State: stateId,
            ZipCode: postalCode
        };

        customSetAddress(customAddress);
        setAddress(customAddress);
        setCity(city);
    };
    const customSetPostalCode = (zipcode: any) => {
        const customAddress: Address = {
            Name: name,
            City: city,
            Street: betweenStreet && betweenStreet !== '' ? `${street}\n${betweenStreet}` : `${street}`,
            State: stateId,
            ZipCode: zipcode
        };

        customSetAddress(customAddress);
        setAddress(customAddress);
        setPostalCode(zipcode);
    };
    const customSetBetweenStreet = (betweenStreet: any) => {
        const customAddress: Address = {
            Name: name,
            City: city,
            Street: betweenStreet && betweenStreet !== '' ? `${street}\n${betweenStreet}` : `${street}`,
            State: stateId,
            ZipCode: postalCode
        };

        customSetAddress(customAddress);
        setAddress(customAddress);
        setBetweenStreet(betweenStreet);
    };
    const customSetStreet = (street: any) => {
        const customAddress: Address = {
            Name: name,
            City: city,
            Street: betweenStreet && betweenStreet !== '' ? `${street}\n${betweenStreet}` : `${street}`,
            State: stateId,
            ZipCode: postalCode
        };
        customSetAddress(customAddress);
        setAddress(customAddress);
        setStreet(street);
    };
    return (
        <div>
            <label
                style={{
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    lineHeight: '19px',
                    marginLeft: '8px'
                }}
            >
                {resources.addressNameLabel}
            </label>
            <input
                type='text'
                name=''
                id=''
                style={{
                    border: '1px solid #878A8C',
                    borderRadius: '2px',
                    boxSizing: 'border-box',
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    lineHeight: '22px',
                    margin: '8px 0px',
                    padding: '8px',
                    width: '100%'
                }}
                value={name}
                onChange={(e: any) => customSetName(e.target.value)}
            />
            <label
                style={{
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    lineHeight: '19px',
                    marginLeft: '8px'
                }}
            >
                {resources.addressStreetLabel1}
            </label>
            <input
                type='text'
                name=''
                id=''
                style={{
                    border: '1px solid #878A8C',
                    borderRadius: '2px',
                    boxSizing: 'border-box',
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    lineHeight: '22px',
                    margin: '8px 0px',
                    padding: '8px',
                    width: '100%'
                }}
                value={street}
                onChange={(e: any) => customSetStreet(e.target.value)}
            />
            <label
                style={{
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    lineHeight: '19px',
                    marginLeft: '8px'
                }}
            >
                {resources.addressBetweenStreetsLabel}
            </label>
            <input
                type='text'
                name=''
                id=''
                style={{
                    border: '1px solid #878A8C',
                    borderRadius: '2px',
                    boxSizing: 'border-box',
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    lineHeight: '22px',
                    margin: '8px 0px',
                    padding: '8px',
                    width: '100%'
                }}
                value={betweenStreet}
                onChange={(e: any) => customSetBetweenStreet(e.target.value)}
            />
            <label
                style={{
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    lineHeight: '19px',
                    marginLeft: '8px'
                }}
            >
                {`${resources.addressDepartmentLabel} *`}
            </label>
            <select
                className='msc-address-form'
                style={{
                    border: '1px solid #878A8C',
                    borderRadius: '2px',
                    boxSizing: 'border-box',
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    lineHeight: '22px',
                    margin: '8px 0px',
                    padding: '8px',
                    width: '100%'
                }}
                name=''
                id=''
                onChange={(e: any) => selectState(e.target.value)}
            >
                <option disabled={true} selected />
                {filteredItems
                    ? filteredItems.map((state: any, index: any) => {
                          if (state.key === '') {
                              return null;
                          } else {
                              return (
                                  <option
                                      value={state.key}
                                      key={state.key}
                                      disabled={state.value === '' ? true : false}
                                      selected={stateId && stateId === state.key ? true : false}
                                  >
                                      {state.value}
                                  </option>
                              );
                          }
                      })
                    : null}
            </select>
            <label
                style={{
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    lineHeight: '19px',
                    marginLeft: '8px'
                }}
            >
                {resources.addressCityLabel}
            </label>
            <input
                type='text'
                name=''
                id=''
                style={{
                    border: '1px solid #878A8C',
                    borderRadius: '2px',
                    boxSizing: 'border-box',
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    lineHeight: '22px',
                    margin: '8px 0px',
                    padding: '8px',
                    width: '100%'
                }}
                value={city}
                onChange={(e: any) => customSetCity(e.target.value)}
            />
            <label
                style={{
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    lineHeight: '19px',
                    marginLeft: '8px'
                }}
            >
                {resources.addressPostalCodeLabel}
            </label>
            <input
                type='text'
                name=''
                id=''
                style={{
                    border: '1px solid #878A8C',
                    borderRadius: '2px',
                    boxSizing: 'border-box',
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    lineHeight: '22px',
                    margin: '8px 0px',
                    padding: '8px',
                    width: '100%'
                }}
                value={postalCode}
                onChange={(e: any) => customSetPostalCode(e.target.value)}
            />
            <label
                style={{
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    lineHeight: '19px',
                    marginLeft: '8px'
                }}
            >
                {' '}
                {resources.addressThreeLetterISORegionNameLabel}
            </label>
            <select
                className='msc-address-form'
                style={{
                    border: '1px solid #878A8C',
                    borderRadius: '2px',
                    boxSizing: 'border-box',
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    lineHeight: '22px',
                    margin: '8px 0px',
                    padding: '8px',
                    width: '100%'
                }}
                name=''
                id=''
                disabled={true}
            >
                <option value='' disabled selected>
                    {countryRegionName || defaultCountryRegionId || 'URY'}
                </option>
            </select>
        </div>
    );
};
